module.exports = "/_next/static/images/newslettersignupbackground-7ef6cd2615b111de0b53fecb99dd30cd.png";